import styles from './organisation-area-content.module.scss';

import { Table } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { QuickColumnFilterPicker } from '../../data-tables/table-quick-filters';
import { PersonalAndGeneralViewV8 } from '../../filters/PersonalAndGeneralView/v8';
import {
  useOrganisationAreaContext,
  useOrganisationAreaSectionMultiselectability,
  useOrganisationAreaSectionVisibility,
} from '../hooks';
import { availableSectionsConfigs, sectionToPickerType } from '../utils';

import { OrganisationAreaCategoriesOverlay } from './organisation-area-categories-overlay';
import { OrganisationAreaGroupsOverlay } from './organisation-area-groups-overlay';
import { OrganisationAreaSection } from './organisation-area-section';
import { OrganisationAreaSectionActions } from './organisation-area-section-actions';
import { OrganisationAreaSectionEditAction } from './organisation-area-section-edit-action';
import { OrganisationAreaSectionHeader } from './organisation-area-section-header';
import { OrganisationAreaSectionMultiselectAction } from './organisation-area-section-multiselect-action';
import { OrganisationAreaSectionTitle } from './organisation-area-section-title';

export const OrganisationAreaContent = ({
  table,
}: {
  table: Table<unknown>;
}) => {
  const { t } = useTranslation();
  const { entity } = useOrganisationAreaContext();
  const sections = availableSectionsConfigs(entity, [
    'general-filters',
    'personal-filters',
  ]);

  const { isVisible } = useOrganisationAreaSectionVisibility({
    entity,
  });
  const { isMultiselectable } = useOrganisationAreaSectionMultiselectability();

  function renderManagedSections() {
    return sections.map((section) => {
      return (
        <OrganisationAreaSection
          key={section.id}
          isVisible={isVisible(section.id)}
        >
          <OrganisationAreaSectionHeader>
            <OrganisationAreaSectionTitle
              rightElement={
                <OrganisationAreaSectionActions>
                  <OrganisationAreaSectionMultiselectAction
                    section={section.id}
                  />

                  <OrganisationAreaSectionEditAction section={section.id} />
                </OrganisationAreaSectionActions>
              }
            >
              {t(section.nameTranslationKey)}
            </OrganisationAreaSectionTitle>
          </OrganisationAreaSectionHeader>

          <OrganisationAreaGroupsOverlay table={table} />
          <OrganisationAreaCategoriesOverlay />

          <QuickColumnFilterPicker
            entity={entity}
            type={sectionToPickerType(section.id)}
            multiple={isMultiselectable(section.id)}
            table={table}
          />
        </OrganisationAreaSection>
      );
    });
  }

  return (
    <div className={styles.root}>
      {renderManagedSections()}

      <PersonalAndGeneralViewV8
        entity={entity}
        hideGeneralFilters={!isVisible('general-filters')}
        hidePersonalFilters={!isVisible('personal-filters')}
        table={table}
      />
    </div>
  );
};
